Vue.component('multiselect', window.VueMultiselect.default);

Vue.component("edict-card", {
    props: ["edict"],
    template: "#edict-card"
});

var vmcontactus = new Vue({
    el: "#vue-edict-search",
    components: {
        vuejsDatepicker
    },
    beforeMount: function () {
        this.response.totalEdicts = parseInt(this.$el.dataset.total);
        this.term = this.$el.dataset.term;
        this.dMin = new Date(parseInt(this.$el.dataset.minDate));
        this.dMax = new Date(parseInt(this.$el.dataset.maxDate));
        this.categoryOptions = window.products;
        if (this.term) {
            this.changeTerm();
        }
    },
    mounted: function () {
        epicaAddEventClick('#vue-edict-search');
    },
    updated: function () {
        epicaAddEventClick('#vue-edict-search');
    },
    data: function () {
        return {
            term: null,
            order: {
                name: "Ordenar por más reciente",
                value: 1
            },
            categories: null,
            es: vdp_translation_es.js,
            from: null,
            to: null,
            response: {
                edicts: [],
                totalEdicts: null
            },
            orderOptions: [{
                    name: "Ordenar por más reciente",
                    value: 1
                },
                {
                    name: "Ordenar por más antiguo",
                    value: 0
                }
            ],
            categoryOptions: [],
            request: {
                page: 1,
                pageSize: 20,
                order: 1
            },
            requestTerm: null,
            loading: false,
            loadingPager: false
        };
    },
    computed: {
        hasModified: function () {
            return !this.loading && (this.requestTerm ||
                this.request.order !== 1 ||
                this.hasFacetSelected);
        },
        facetCategories: function () {
            return this.hasModified ? this.response.facets.product : this.categoryOptions;
        },
        facetDate: function () {
            const fromT = this.from ? new moment(this.from).format("MMM DD, YYYY") : "*";
            const toT = this.to ? new moment(this.to).format("MMM DD, YYYY") : "*";
            return this.to || this.from ? `${fromT} - ${toT}` : null;
        },
        hasFacetSelected: function () {
            return (
                (this.categories && this.categories.length) ||
                this.to ||
                this.from
            );
        },
        fromDisable: function () {
            var to = (this.to || this.dMax) ? (!this.to || this.to > this.dMax ? this.dMax : this.to) : null;
            return to ? {
                from: to,
                to: this.dMin
            } : {};
        },
        toDisable: function () {
            var from = (this.from || this.dMin) ? (this.from < this.dMin ? this.dMin : this.from) : null;
            return from ? {
                to: from,
                from: this.dMax
            } : {};
        },
        enabled: function () {
            return (
                this.response.edicts.length < this.response.totalEdicts &&
                !this.loadingPager
            );
        }
    },
    methods: {
        changeFacet: function () {
            this.request.page = 1;
            this.request.order = this.order.value;
            this.request.product = !this.categories ?
                null :
                this.categories.map(q => q.key);

            this.request.startDate = this.from;
            this.request.endDate = this.to;
            this.doNewSearch();
        },
        changeTerm: function () {
            if (this.term != this.request.term) {
                this.request = Object.assign(this.request, {
                    term: this.term
                });
                this.categories = null;
                this.from = null;
                this.to = null;
                this.changeFacet();
            }
        },
        removeFilterDate: function () {
            this.to = null;
            this.from = null;
            this.changeFacet();
        },
        removeCategory: function (idx) {
            this.categories.splice(idx, 1);
            this.changeFacet();
        },
        doNewSearch: function () {
            const _self = this;
            _self.loading = true;
            axios
                .post("/api/edict/search", this.request)
                .then((resp) => {
                    const res = resp.data;
                    res.edicts = res.edicts.map((q) => {
                        q.dateString = q.publishDates
                            .map((p) => new moment(p).format("MMM DD, YYYY"))
                            .reduce((pv, sv) => {
                                return pv + ' / ' + sv;
                            });
                        return q;
                    });
                    _self.response = res;
                    _self.requestTerm = _self.term;
                    _self.loading = false;
                    if (!_self.hasModified) {
                        Vue.set(
                            _self.response,
                            "edicts",
                            []
                        );
                    }
                })
                .catch((error) => {})
                .then(() => {
                    _self.loading = false;
                });

        },
        nextPage: function () {
            this.request.page++;
            const _self = this;
            _self.loadingPager = true;
            axios
                .post("/api/edict/search", this.request)
                .then((resp) => {
                    const res = resp.data;
                    res.edicts = res.edicts.map((q) => {
                        q.dateString = q.publishDates
                            .map((p) => new moment(p).format("MMM DD, YYYY"))
                            .reduce((pv, sv) => {
                                return pv + ' / ' + sv;
                            });
                        return q;
                    });
                    Vue.set(
                        _self.response,
                        "edicts",
                        _self.response.edicts.concat(res.edicts)
                    );
                })
                .catch((error) => {})
                .then(() => {
                    _self.loadingPager = false;
                });;
        }
    }
});